import Papa from 'papaparse';

const SHEET_CSV_URL_CELULARES = 'https://docs.google.com/spreadsheets/d/1SfR8dxL9CPI1jkWxs-Y7tldJGLKR0xYsWte2VVaYz4U/export?format=csv&gid=0';
const SHEET_CSV_URL_APPLE = 'https://docs.google.com/spreadsheets/d/1SfR8dxL9CPI1jkWxs-Y7tldJGLKR0xYsWte2VVaYz4U/export?format=csv&gid=1343245234';

// Cache para los datos de colores
let colorDataCache = null;
let lastFetchTime = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

// Descarga y parsea el CSV de Google Sheets (celulares y apple)
export async function fetchColorData() {
  console.log('🔄 fetchColorData iniciado');
  const now = Date.now();
  if (colorDataCache && (now - lastFetchTime) < CACHE_DURATION) {
    console.log('✅ Usando cache de colores');
    return colorDataCache;
  }
  try {
    console.log('📊 Fetching desde Google Sheets:', SHEET_CSV_URL_CELULARES);
    // Fetch solo celulares (iPhone está en la misma hoja)
    const respCelulares = await fetch(SHEET_CSV_URL_CELULARES);
    console.log('📡 Respuesta de Google Sheets:', respCelulares.status, respCelulares.statusText);
    
    if (!respCelulares.ok) {
      throw new Error(`HTTP error! status: ${respCelulares.status}`);
    }
    
    const csvCelulares = await respCelulares.text();
    console.log('📄 CSV obtenido, longitud:', csvCelulares.length);
    
    const parsedCelulares = Papa.parse(csvCelulares, { header: false, skipEmptyLines: true });
    console.log('📋 CSV parseado, filas:', parsedCelulares.data.length);
    const colorData = { celulares: {}, apple: {}, xiaomi: {}, samsung: {}, moto: {} };
    
    // Procesar todos los productos (incluyendo iPhone)
    console.log('📊 Primera fila (headers):', parsedCelulares.data[0]);
    for (let i = 1; i < parsedCelulares.data.length; i++) {
      const row = parsedCelulares.data[i];
      console.log(`📋 Fila ${i}:`, row);
      
      // Corregir índices según la estructura real del CSV
      // Columna 1: Producto, Columna 2: Color, Columna 4: Stock
      const product = row[1]?.trim();
      const color = row[2]?.trim();
      const stock = row[4]?.trim();
      
      console.log(`   Producto: "${product}", Color: "${color}", Stock: "${stock}"`);
      
      // Solo procesar filas que tengan producto y color (stock puede estar vacío)
      if (!product || !color) {
        console.log(`   ⚠️ Fila ${i} ignorada - producto o color vacío`);
        continue;
      }
      
      // Si no hay stock, usar "Sin Stock" por defecto
      const stockStatus = stock || "Sin Stock";
      
      // Determinar la categoría basada en el nombre del producto
      const productLower = product.toLowerCase();
      let targetCategory = 'celulares'; // Por defecto
      
      if (productLower.includes('iphone')) {
        targetCategory = 'apple';
      } else if (productLower.includes('xiaomi') || productLower.includes('redmi') || productLower.includes('poco')) {
        targetCategory = 'xiaomi';
      } else if (productLower.includes('samsung')) {
        targetCategory = 'samsung';
      } else if (productLower.includes('moto')) {
        targetCategory = 'moto';
      }
      
      if (!colorData[targetCategory][product]) colorData[targetCategory][product] = [];
      colorData[targetCategory][product].push({
        name: color,
        stock: stockStatus,
        available: stockStatus.toLowerCase().includes('stock') && !stockStatus.toLowerCase().includes('sin')
      });
    }
    
    console.log('📊 Datos de colores procesados:', colorData);
    colorDataCache = colorData;
    lastFetchTime = now;
    return colorData;
  } catch (error) {
    console.error('❌ Error en fetchColorData:', error);
    return colorDataCache || { celulares: {}, apple: {} };
  }
}

// Normalización agresiva para máxima coincidencia flexible
function normalize(str) {
  return str
    .normalize('NFD').replace(/\p{Diacritic}/gu, '') // Quitar tildes
    .replace(/\([^)]*\)/g, '') // Quitar paréntesis y su contenido
    .replace(/\b(5g|4g|ds|con leica|sin stock|stock|gb|tb|m1|m2|gen|inch|wi[-]?fi|usb[-]?c|c\/|c--|c-)/gi, '') // Quitar palabras irrelevantes
    .replace(/[+\-/().,]/g, '') // Quitar signos
    .replace(/\d{1,2}\s*gb/gi, '') // Quitar cantidades de GB
    .replace(/\d{1,2}\s*tb/gi, '') // Quitar cantidades de TB
    .replace(/\s+/g, '') // Quitar espacios
    .toLowerCase();
}

// Busca colores de un producto (nombre flexible y tipo)
export async function getProductColorsDynamic(productName, type = 'celulares') {
  console.log('🎨 getProductColorsDynamic llamado con:', { productName, type });
  const colorData = await fetchColorData();
  const normalizedInput = normalize(productName);
  console.log('🔍 Nombre normalizado:', normalizedInput);
  
  // Determinar automáticamente la categoría basada en el nombre del producto
  const productLower = productName.toLowerCase();
  let searchType = type; // Usar el tipo proporcionado como fallback
  
  if (productLower.includes('iphone')) {
    searchType = 'apple';
  } else if (productLower.includes('xiaomi') || productLower.includes('redmi') || productLower.includes('poco')) {
    searchType = 'xiaomi';
  } else if (productLower.includes('samsung')) {
    searchType = 'samsung';
  } else if (productLower.includes('moto')) {
    searchType = 'moto';
  }
  
  const dataSet = colorData[searchType] || {};
  console.log(`🔍 Buscando en categoría: ${searchType}`);
  console.log(`🔍 Productos disponibles en ${searchType}:`, Object.keys(dataSet));
  
  // 1. Intentar match exacto
  for (const key in dataSet) {
    const normalizedKey = normalize(key);
    console.log(`🔍 Comparando: "${normalizedKey}" vs "${normalizedInput}"`);
    if (normalizedKey === normalizedInput) {
      console.log(`✅ Match exacto encontrado: ${key}`);
      return dataSet[key];
    }
  }
  
  // 2. Intentar match por inclusión
  for (const key in dataSet) {
    const normalizedKey = normalize(key);
    if (normalizedKey.includes(normalizedInput) || normalizedInput.includes(normalizedKey)) {
      console.log(`✅ Match por inclusión encontrado: ${key}`);
      return dataSet[key];
    }
  }
  
  console.log(`❌ No se encontraron colores para: ${productName}`);
  return [];
}

export function clearColorCache() {
  colorDataCache = null;
  lastFetchTime = 0;
}

// Función de prueba para verificar datos
export async function testColorData() {
  console.log('🧪 Iniciando prueba de datos de colores...');
  try {
    const data = await fetchColorData();
    console.log('✅ Datos obtenidos:', data);
    
    // Verificar estructura
    const categories = Object.keys(data);
    console.log('📂 Categorías disponibles:', categories);
    
    categories.forEach(category => {
      const products = Object.keys(data[category]);
      console.log(`📱 ${category}: ${products.length} productos`);
      if (products.length > 0) {
        console.log(`   Ejemplo: ${products[0]}`, data[category][products[0]]);
      }
    });
    
    return data;
  } catch (error) {
    console.error('❌ Error en prueba:', error);
    return null;
  }
}

// Función para verificar si un producto tiene colores disponibles en stock
export async function hasAvailableColors(productName) {
  const colors = await getProductColorsDynamic(productName);
  return colors.some(color => color.available);
}

// Función para obtener todos los productos con colores disponibles
export async function getAvailableProducts() {
  const colorData = await fetchColorData();
  const availableProducts = [];
  
  // Revisar todas las categorías
  const categories = ['celulares', 'apple', 'xiaomi', 'samsung', 'moto'];
  
  for (const category of categories) {
    const products = colorData[category] || {};
    for (const productName in products) {
      const colors = products[productName];
      const hasStock = colors.some(color => color.available);
      if (hasStock) {
        availableProducts.push({
          name: productName,
          category: category,
          colors: colors
        });
      }
    }
  }
  
  return availableProducts;
} 